import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";

import { useState } from "react";
import { showToastMessage, showToastMessagePostRequest } from "../../../../utils/toasts";
import BasicDetails from "./views/BasicDetails";
import ProductDetails from "./views/ProductDetails";
import { useCreateBolreplenishmentMutation } from "../../../../newapi/webshop/bolreplenishmentSlice";
const MpAddBolReplenishment = (props) => {
    const {t} = useTranslation();
    const [saving, setSaving] = useState(false);


    const onSave = () => {
        props.handleClose();
    }

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useCreateBolreplenishmentMutation} isModal title={t("new_bol_replenishment")}>
                <BasicDetails/>
                <ProductDetails/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpAddBolReplenishment;